export const SOCKET_EVENT = {
  CONNECT: 'connect',
  DISCONNECT: 'disconnect',
  EVENT: 'event',
  ERROR: 'error',
  SEND_OK: 'send:ok',
  GENERATION_DETAIL: 'generation:detail',
  ONGOING_DETAIL: 'ongoing:detail',
  GENERATION_AI_CHAT: 'generation:ai-chat',
  ONGOING_AI_CHAT: 'ongoing:ai-chat',
  GENERATION_PRODUCT: 'generation:product',
  ONGOING_PRODUCT: 'ongoing:product',
  NOTIFICATION_CREDIT: 'notification:credit',
  GENERATION_BANNER: 'generation:banner',
  ONGOING_BANNER: 'ongoing:banner',
  GENERATION_AI_STUDIO: 'generation:ai-studio',
  ONGOING_AI_STUDIO: 'ongoing:ai-studio',
  GENERATION_VIDEO: 'generation:video',
  ONGOING_VIDEO: 'ongoing:video',
  NOTIFICATION_PRODUCT: 'notification:product',
} as const;

type SocketEvent = (typeof SOCKET_EVENT)[keyof typeof SOCKET_EVENT];

export interface WorkerMessage<T extends MessageData = MessageData> {
  type: 'connect' | 'disconnect' | 'send';
  event?: string;
  data?: T;
}

export interface SocketWorkerMessage<T extends MessageData = MessageData> {
  type: SocketEvent;
  data?: T;
}

export interface MessageData {
  uid: string;
  [key: string]: unknown;
}

export interface ISocketService {
  initialize(): void;
  isConnected(): boolean;
  on(eventName: string, callback: (data: unknown) => void): void;
  off(eventName: string, callback: (data: unknown) => void): void;
  connectSocket(): void;
  disconnectSocket(): void;
  send(event: string, data?: MessageData, callback?: () => void): void;
}

export interface SocketResponse<T> {
  data: T;
  message: string;
  code: string;
  status: number;
}
